import React from "react";
import _ from "lodash";
import { t } from "i18next";
import s from "./resourcesCounter.scss";

export default function ResourcesCounter({ summary }) {
  const summaryNames = Object.keys(summary);

  return (
    <div className={s.resourcesCounter}>
      {_.compact(
        _.map(summaryNames, (k) => {
          const v = summary[k];
          return (
            <div className={s.infoBox} key={k}>
              <div className={s.titleBox}>{t(`dashboard.label.${k}`)}</div>
              <div className={s.numberBox}>
                {!v && v !== 0 ? "-" : typeof v === "number" ? new Intl.NumberFormat(navigator.language).format(v) : v}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
